module.exports = __webpack_public_path__ + "img/unknown.c8cda825.svg";